import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { localhostPrinterPort } from './constants';
import { savePrinterNameToLocalStorage } from './thunk';
export const printerServiceApi = createApi({
    reducerPath: 'api/printerService',
    tagTypes: ['Printer'],
    baseQuery: fetchBaseQuery({ baseUrl: `http://localhost:${localhostPrinterPort}/api/` }),
    endpoints: (builder) => ({
        getPrinters: builder.query({
            query: () => ({
                method: 'GET',
                url: 'printerservice/getprinters',
            }),
            transformResponse: (response) => {
                return response.payload;
            },
        }),
        getCurrentPrinter: builder.query({
            query: () => ({
                method: 'GET',
                url: 'printerservice/getcurrentprinter',
                cache: 'no-cache',
            }),
            transformResponse: (response) => {
                return response.payload;
            },
            providesTags: ['Printer'],
        }),
        setCurrentPrinter: builder.mutation({
            query: (printerName) => ({
                method: 'GET',
                url: 'printerservice/setcurrentprinter',
                params: { printerName },
                cache: 'no-cache',
            }),
            onQueryStarted: async (printerName, { dispatch, queryFulfilled }) => {
                try {
                    dispatch(savePrinterNameToLocalStorage(printerName));
                    await queryFulfilled;
                }
                catch {
                    //
                }
            },
            invalidatesTags: ['Printer'],
        }),
    }),
});
export const { useGetPrintersQuery, useGetCurrentPrinterQuery, useSetCurrentPrinterMutation } = printerServiceApi;
